import {mapLegacyPagination} from '@/store/utils'
import '@/store/api/product-inventory/typedefs'
import api from '@/store/api/product-inventory'
import * as mutationTypes from './mutation-types'
// Modules
import supplier from './supplier'

const initialState = () => ({
    suppliers: {
        data: [],
        pagination: {}
    },
    suppliersSearch: {
        data: []
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        suppliers: state => state.suppliers,
        suppliersSearch: state => state.suppliersSearch
    },
    actions: {
        /**
         * @param {SearchQuery} query
         * @returns {Promise<*>}
         */
        listSuppliers: async ({commit, dispatch}, query) => {
            try {
                const response = await api.suppliers.searchSuppliers(query)
                commit(mutationTypes.SET_SUPPLIERS, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {SearchQuery} query
         * @returns {Promise<*>}
         */
        searchSuppliers: async ({commit, dispatch}, query) => {
            try {
                const response = await api.suppliers.searchSuppliers(query)
                commit(mutationTypes.SET_SUPPLIERS_SEARCH, response)
                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetSuppliers: async ({commit}) => commit(mutationTypes.RESET_SUPPLIERS),
        resetSuppliersSearch: async ({commit}) => commit(mutationTypes.RESET_SUPPLIERS_SEARCH)
    },
    modules: {
        supplier
    },
    mutations: {
        [mutationTypes.RESET_SUPPLIERS]: state => Object.assign(state, initialState()),
        [mutationTypes.RESET_SUPPLIERS_SEARCH]: state => state.suppliersSearch = initialState().suppliersSearch,
        [mutationTypes.SET_SUPPLIERS]: (state, data) => {
            state.suppliers = {
                ...data,
                pagination: mapLegacyPagination(data.pagination)
            }
        },
        [mutationTypes.SET_SUPPLIERS_SEARCH]: (state, data) => state.suppliersSearch = data
    }
}
